<template>
    <!-- Topbar -->
    <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow" v-if="$store.getters['auth/check']">

        <!-- Sidebar Toggle (Topbar) -->
        <button @click="setToggle()" id="sidebarToggleTop" class="btn btn-link rounded-circle mr-3">
          <fa icon="bars" fixed-width />
        </button>
        <h5 class="my-0 mr-md-auto font-weight-normal" v-show="toggleStatus">Portal de Clientes</h5>
        
        <!-- Topbar Navbar -->
        <ul class="navbar-nav ml-auto">

        <div class="topbar-divider d-none d-sm-block"></div>

        <!-- Nav Item - User Information -->
        <li class="nav-item dropdown no-arrow">
            <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="mr-2 d-none d-lg-inline text-gray-600 small">{{ user.nombre }}</span>
            <img :src="user.photoURL || 'https://www.gravatar.com/avatar/ec0d530c9251f9241c8eab727e06ae42.jpg?s=200&d=mm'" class="img-profile rounded-circle">
            </a>
            <!-- Dropdown - User Information -->
            <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
            <span class="dropdown-item pl-3" @click.prevent="logout">
                <fa icon="sign-out-alt" fixed-width/>
                Salir
            </span>
            </div>
        </li>

        </ul>

    </nav>
    <!-- End of Topbar -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Topbar',

  computed: mapGetters({
    user: 'auth/user',
    toggleStatus: 'layout/toggleStatus'
  }),

  methods: {
    ...mapActions({
      setToggle: 'layout/setToggleBar'
    }),
    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    },
    hasRole (roles) {
      if (this.$store.getters['auth/check']) {
        return this.$store.getters['auth/hasRole'](roles)
      }
      return false
    }
  }
}
</script>

<style scoped>
.profile-photo {
  width: 2rem;
  height: 2rem;
  margin: -.375rem 0;
}
</style>
